import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import { isMobile } from 'react-device-detect';
import { getReportParams, report } from '../../../middleware/report';

const SupportTopics = (props) => {
    const backgroundImageWeb = 'url(' + Config.epiBaseUrl + props.iContent.backgroundImageWeb?.expandedValue?.url + ')';
    const backgroundImageMobile = 'url(' + Config.epiBaseUrl + props.iContent.backgroundImageMobile?.expandedValue?.url + ')';

    useEffect(() => {
        reportDWH({ actionType: 'SupportCenterSecondaryPage', status: 'Ongoing', messageText: 'SupportCenterSecondaryPage Displayed' });
    }, []);

    return (
        <div className='support-topics-block' style={{ backgroundImage: isMobile ? backgroundImageMobile : backgroundImageWeb }}> 

            <div className='support-topics'>

                {
                    props.iContent.title?.value &&
                    <div className='title'> {props.iContent.title?.value} </div>
                }

                {
                    props.iContent.subTitle?.value &&
                    <div className='sub-title'> {props.iContent.subTitle?.value} </div>
                }

                <div className='topics-wrapper'>
                    {
                        props.iContent.supportTopics?.expandedValue &&
                        props.iContent.supportTopics?.expandedValue.map((item, index) => {
                            return (
                                <a href='#' key={index} className='topic-item' onClick={(e) => handleTopicClick(e, item)}>
                                    
                                    {
                                        item.icon?.expandedValue &&
                                        <div className='icon-wrapper'> <Image src={Config.epiBaseUrl + item.icon?.expandedValue?.url} /> </div>
                                    }
                                    
                                    <div className='text-wrapper'>
                                        {
                                            item.tagText?.value &&
                                            <div className='topic-tag-wrapper'>
                                                <div className='topic-tag' style={{ backgroundColor: item.tagBackgroundColor?.value, color: item.tagTextColor?.value }}> {item.tagText?.value} </div>
                                            </div>
                                        }
                                        <div className='text' onClick={(e) => handleTopicClick(e, item)}> {item.text?.value} </div>
                                    </div>
                                </a>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );

    function reportDWH(params) {
        const isAuthenticated = props.loginData?.isFullAuthenticated || props.loginData?.isOtpAuthenticated || props.loginData?.isOtpExtendedAuthenticated || props.loginData?.isSilentOtpAuthenticated;

        let reportParams = getReportParams();
        reportParams.area = 'Support';
        reportParams.subArea = 'SupportCenter';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = params.actionType;
        reportParams.status = params.status;
        reportParams.messageText = params.messageText;
        reportParams.customerName = isAuthenticated ? `${props.loginData?.userDetails?.firstName} ${props.loginData?.userDetails?.lastName}` : '';
        reportParams.email = '';
        reportParams.banId = '';
        reportParams.idNumber = props.loginData?.userDetails?.IDNumber ?? '';
        reportParams.subscriber = props.loginData?.userDetails?.contactNumber ?? '';
        reportParams.param1 = props.iContent.title?.value;
        reportParams.param9 = isAuthenticated ? (props.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי') : ''
        reportParams.param10 = props.loginData?.isFullAuthenticated ? 'לקוח' : props.loginData?.isOtpExtendedAuthenticated ? 'OTP מורחב' : props.loginData?.isOtpAuthenticated ? 'OTP' : '';
        report(reportParams);
    }

    function handleTopicClick(e, item) {
        e.preventDefault();
        buildUrlAndOpenSameWindow(item.link?.value);
    }

};

const mapStateToProps = (state) => {
    return {
        loginData: state.authentication.loginData
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SupportTopics);
